import { LocalDate } from '@js-joda/core';

import { dateFormatter } from '@dreryk/react-common';
import { Range } from '@dreryk/watermelon';

type RangeCellProps = {
   range: Range<LocalDate>;
};

export const RangeCell = (props: RangeCellProps): JSX.Element => {
   const formattedLowerEndpoint = dateFormatter(props.range.lowerEndpoint());
   const formattedUpperEndpoint = dateFormatter(props.range.upperEndpoint());
   const formattedRangeText = `${formattedLowerEndpoint} - ${formattedUpperEndpoint}`;
   return <>{formattedRangeText}</>;
};
